import { call, takeLatest, put, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';

function* fetchAllRejectionTypes() {
  try {
    const { data } = yield call(api.get, {
      route: 'RejectionType',
    });
    const allRejectionTypesData = data;
    yield put(Actions.setAllRejectionTypes({ allRejectionTypesData }));
  } catch (error) {
    notification('error', error);
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL_REJECTION_TYPES, fetchAllRejectionTypes)]);
}
